// PageVariablesApolices.js

export const pageVariables = {
    headers: [
        'NOME', 'Nº APÓLICE', 'EMPRESA', 'SEGURADORA', 'ENCAMPAÇÃO', 'PERM. VENDA', 'CANCELADA'
    ],
    headerInfo: {
        title: "Apólices",
        description: "Esta seção fornece informações detalhadas sobre as apólices, incluindo dados como segurado, tipo de cobertura, valor da apólice e vigência. Acompanhe e gerencie as apólices emitidas para garantir que estejam adequadas às necessidades dos segurados e cumpram as exigências contratuais."
    },     
    inputs: [
        {
            name: "nome",
            type: "text",
            label: "Nome da Apólice"
        },
        {
            name: "numero",
            type: "text",
            label: "Número da Apólice"
        },
        {
            name: "data_aniversario_apolice",
            type: "date",
            label: "Data de Aniversário da Apólice"
        }
    ],
    page: process.env.VUE_APP_API_URL+"apolices",
    seachFilterKey: "nome"
};
